import { GlobalEngagementsConstant } from '../../global-engagements/constants/global-engagements.constants';

export const convertDate = (data: string): string => {
  const dateObj: Date = new Date(data);
  const day: string = String(dateObj.getDate()).padStart(2, '0');
  const month: string = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year: number = dateObj.getFullYear();
  return `${day}/${month}/${year}`;
};

export const convertTime = (data: string): string => {
  const dateObj: Date = new Date(data);
  const hours: string = String(dateObj.getHours()).padStart(2, '0');
  const minutes: string = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds: string = String(dateObj.getSeconds()).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export function isBusinessDay(date: Date): boolean {
  const day: number = date.getDay();
  const isWeekend = day === 0 || day === 6; // Sunday = 0, Saturday = 6
  return !isWeekend;
}

export const convertAuditDate = (data: string): string => {
  const [datePart] = data.split(' ');
  const [month, day, year] = datePart.split('/');
  return `${month}/${day}/${year}`;
};

export const convertAuditTime = (data: string): string => {
  const [, timePart, period] = data.split(' ');
  const [hours, minutes] = timePart.split(':');
  return `${hours}:${minutes} ${period}`;
};

export const hasValue = (value: any): boolean => {
  return (
    value !== null &&
    value !== undefined &&
    value !== GlobalEngagementsConstant.EMPTY_STRING
  );
};

export const parseCTDate = (dateString: string): Date => {
  // Remove the 'CT' part and split the date and time
  const [datePart, timePart, period] = dateString.replace(' CT', '').split(' ');
  const [month, day, year] = datePart.split('/').map(Number);
  const [hours, minutes] = timePart.split(':').map(Number);

  // Convert to 24-hour format
  const adjustedHours =
    period === 'PM' && hours !== 12
      ? hours + 12
      : hours === 12 && period === 'AM'
      ? 0
      : hours;

  // Create a UTC date and adjust for Central Time (-6 hours)
  const utcDate = new Date(
    Date.UTC(year, month - 1, day, adjustedHours, minutes)
  );
  return new Date(utcDate.getTime() - 6 * 60 * 60 * 1000); // Adjust for CT timezone
};

export const compareDates = (date1: string, date2: string): number => {
  const parsedDate1 = parseCTDate(date1);
  const parsedDate2 = parseCTDate(date2);

  if (parsedDate1 < parsedDate2) {
    return -1; // date1 is earlier
  } else if (parsedDate1 > parsedDate2) {
    return 1; // date1 is later
  } else {
    return 0; // dates are equal
  }
};

export const isNotNullOrUndefinedOrEmpty = (value: any): boolean => {
  return value !== null && value !== undefined && value !== '';
};
